module.exports = __webpack_public_path__ + "static/media/acerta-headset.fa8a46ca.svg";